// extracted by mini-css-extract-plugin
export default {"label":"iaBW4L76ydK2GTcugLBQ"};